export default __webpack_public_path__ + "static/screeny-130-gpz-unica-m-2-45b4411d45e602b00472280ca08c43f0.jpg";